import { ProjectService } from "src/app/services/project.service";
import { IRelectureSubRequest, IRequest, Request, RequestStatus } from "../request.model";
import _ from "lodash";
import { FlowType } from "../../proofreading.model";
import { IUploadedFile } from "src/app/services/file.service";
import { MasterProjectService } from "src/app/services/project-master.service";
import { RequestType } from "src/app/LIVECO.define";

export interface IBATRepositoryRequest extends IRequest {
    files?: IUploadedFile[];
}

export class BATRepositoryRequest extends Request implements IBATRepositoryRequest {
    override type: RequestType = RequestType.BAT_REPOSITORY;
    override flow: FlowType | null = FlowType.BAT;
    files?: IUploadedFile[];
    skipRelectureIncrement?: boolean;

    override relecture: IRelectureSubRequest = {
        proofreadingsID: [],
        members: []
    };

    override get isEditable() {
        return this.status !== RequestStatus.CLOSED && this.status !== RequestStatus.DELIVERED;
    }

    constructor(data: Partial<BATRepositoryRequest>) {
        super(data);
        this.init(data);
    }

    onProjectCreation(service: ProjectService, master_service: MasterProjectService, lifecycle: "init" | "submit"): Promise<void> | void {
        switch (lifecycle) {
            case "init":
                this.insertRequestMemberInProjectMember(service);
                // this.flagLimitedCreation(service);
                this.setFlowsInProject(service);
                this.insertFileRepositoryInProject(service);
                this.flagLimitedCreation(service);

                break;
            case "submit":
                break;
        }
        super.onProjectCreation(service, master_service, lifecycle);
    }

    onProjectEdition(service: ProjectService): void {
        const flows = service?.current?.custom?.general?.flows;
        if (Array.isArray(flows) && flows.length === 1 && flows[0] === FlowType.BAT) {
            this.flagLimitedCreation(service);
        }
        super.onProjectEdition(service);
    }

    private flagLimitedCreation(service: ProjectService) {
        service.s_requests.setFlag("project-limited-creation", ['base'] /** select only mandatory fields */);
    }

    private insertRequestMemberInProjectMember(service: ProjectService) {
        // Set request member in project member
        _.set(service.current || {}, 'custom.members', this.relecture?.members);
        // flag the easydiadem service so member edit is disabled
        service.s_requests.setFlag("project-members-creation-locked", true);
    }


    private setFlowsInProject(service: ProjectService) {
        _.set(service.current || {}, 'custom.general.flows', [FlowType.BAT]);

    }

    private insertFileRepositoryInProject(service: ProjectService) {
        this.files = this.files || [];
        this.files.forEach((file) => {
            const file_bat = {
                proofreadingID: null,
                file: [file]
            }
            _.set(service.current || {}, 'custom.bat.file_bat[0]', file_bat);
        });       
    }
}
